import { isTouchable, isWeb } from "@tamagui/constants";
import { useDidFinishSSR } from "@tamagui/use-did-finish-ssr";
const useIsTouchDevice = () => {
  return !isWeb ? true : useDidFinishSSR() ? isTouchable : false;
};
export {
  useIsTouchDevice
};
//# sourceMappingURL=useIsTouchDevice.js.map
